import { Injectable } from '@angular/core';

import { ConfigParserService } from '../services/config-parser.service';

export interface User {
    companyDisplayName: string;
    displayName: string;
    hasNoLicense: boolean;
    hasTrialSubscription: boolean;
    isAdmin: boolean;
    isEdu: boolean;
    isEduFaculty: boolean;
    isEduStudent: boolean;
    isSmb: boolean;
    isIw: boolean;
    isDynamics: boolean;
    isGcc: boolean;
    isValid: boolean;
    mruAvailable: boolean;
    themed: boolean;
    themeId: string;
    isFirstRelease: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class UserContextService {
    public readonly user: User;

    constructor(configParserService: ConfigParserService) {
        // Initialize to default values if there was failure to read user context from page response
        this.user = configParserService.parse<User>('userContext') || {
            companyDisplayName: null,
            displayName: null,
            hasNoLicense: false,
            hasTrialSubscription: false,
            isAdmin: false,
            isEdu: false,
            isEduFaculty: false,
            isEduStudent: false,
            isSmb: false,
            isIw: false,
            isDynamics: false,
            isGcc: false,
            isValid: false,
            mruAvailable: false,
            themed: false,
            themeId: 'Unknown',
            isFirstRelease: false
        };

        this.user.mruAvailable = this.user.isValid && !this.user.hasNoLicense;
    }
}
